<template>
  <g
    :transform="`matrix(1,0,0,1,${svgX},${svgY})`"
    v-b-tooltip="tooltip"
  >
    <circle
      r="1.75"
      cx="0"
      cy="0"
      :fill="color"
      stroke="#00000055"
      stroke-width="0.05"
    />
  </g>
</template>

<script>
import { cartesianPointToSvg } from '@/domain/data/installation/engineering/chromatography/polygonalChart/svgChartUtils';

const DEFAULT_COLOR = '#000000';

/**
 * Representa um valor/ponto nos gráficos poligonais.
 * O conteúdo desde componente é SVG.
 */
export default {
  props: {
    /**
     * Dados para o valor/ponto no gráfico.
     * @type {import('./index.vue').ColoredChartValue}
     */
    value: Object,
  },
  computed: {
    svgValue() {
      return cartesianPointToSvg([this.value.x, this.value.y]);
    },
    svgX() {
      return this.svgValue[0];
    },
    svgY() {
      return this.svgValue[1];
    },
    tooltip() {
      return this.value.name;
    },
    color() {
      return this.value.color || DEFAULT_COLOR;
    },
  },
};
</script>
